import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { GetHarvestBlocksInputDto, HarvestBlockCreateDto, HarvestBlockDto, HarvestBlockExcelDownloadDto, HarvestBlockUpdateDto } from '../dtos/harvest-block/models';
import type { DownloadTokenResultDto, GetByIdsInputDto } from '../dtos/shared/models';

@Injectable({
  providedIn: 'root',
})
export class HarvestBlockService {
  apiName = 'WoodSupply';
  

  create = (input: HarvestBlockCreateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, HarvestBlockDto>({
      method: 'POST',
      url: '/api/woodSupply/harvestBlocks',
      body: input,
    },
    { apiName: this.apiName,...config });
  

  delete = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/woodSupply/harvestBlocks/${id}`,
    },
    { apiName: this.apiName,...config });
  

  deleteByIds = (ids: number[], config?: Partial<Rest.Config>) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: '/api/woodSupply/harvestBlocks',
      params: { ids },
    },
    { apiName: this.apiName,...config });
  

  get = (id: number, config?: Partial<Rest.Config>) =>
    this.restService.request<any, HarvestBlockDto>({
      method: 'GET',
      url: `/api/woodSupply/harvestBlocks/${id}`,
    },
    { apiName: this.apiName,...config });
  

  getDownloadToken = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, DownloadTokenResultDto>({
      method: 'GET',
      url: '/api/woodSupply/harvestBlocks/download-token',
    },
    { apiName: this.apiName,...config });
  

  getList = (input: GetHarvestBlocksInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<HarvestBlockDto>>({
      method: 'GET',
      url: '/api/woodSupply/harvestBlocks',
      params: { name: input.name, code: input.code, propertyId: input.propertyId, creationDate: input.creationDate, creationDateFrom: input.creationDateFrom, creationDateTo: input.creationDateTo, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListAsExcelFile = (input: HarvestBlockExcelDownloadDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, Blob>({
      method: 'GET',
      responseType: 'blob',
      url: '/api/woodSupply/harvestBlocks/as-excel-file',
      params: { downloadToken: input.downloadToken, fields: input.fields, name: input.name, code: input.code, propertyId: input.propertyId, creationDate: input.creationDate, creationDateFrom: input.creationDateFrom, creationDateTo: input.creationDateTo, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });
  

  getListByIds = (input: GetByIdsInputDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, HarvestBlockDto[]>({
      method: 'GET',
      url: '/api/woodSupply/harvestBlocks/by-ids',
      params: { ids: input.ids },
    },
    { apiName: this.apiName,...config });
  

  update = (id: number, input: HarvestBlockUpdateDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, HarvestBlockDto>({
      method: 'PUT',
      url: `/api/woodSupply/harvestBlocks/${id}`,
      body: input,
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
